import React, { Component } from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./Components/App.css";
import Home from "./Home";
import TheHouse from "./TheHouse";
import Classes from "./Classes";
import Coaches from "./Components/Coaches";
import Physiotherapists from "./Components/Physiotherapists";
import PhysiotherapistsForm from "./Components/PhysiotherapistsForm";
import PhysiotherapistsApplyForm from "./Components/PhysiotherapistsApplyForm";
import Nutritionists from "./Components/Nutritionists";
import NutritionistsForm from "./Components/NutritionistsForm";
import NutritionistsApplyForm from "./Components/NutritionistsApplyForm";
import CoachesApplyForm from "./Components/CoachesApplyForm";
import CoachesForm from "./Components/CoachesForm";
import { BrowserRouter , Routes, Route } from "react-router-dom";
export default class App extends Component {
 
  render() {
    return (
      <BrowserRouter>
      
        <Routes>
         
           
              <Route exact path="/" element={<Home/>} />
              <Route exact path="/Coaches" element={<Coaches/>} />
              <Route exact path="/Coaches/ApplyForm" element={<CoachesApplyForm/>} />
              <Route exact path="/Coaches/Form" element={<CoachesForm/>} />
              <Route exact path="/TheHouse" element={<TheHouse/>} />
              <Route exact path="/Physiotherapists" element={<Physiotherapists/>} />
              <Route exact path="/Physiotherapists/Form" element={<PhysiotherapistsForm/>} />
              <Route exact path="/Physiotherapists/ApplyForm" element={<PhysiotherapistsApplyForm/>} />
              <Route exact path="/Nutritionists" element={<Nutritionists/>} />              
              <Route exact path="/Nutritionists/Form" element={<NutritionistsForm/>} />
              <Route exact path="/Nutritionists/ApplyForm" element={<NutritionistsApplyForm/>} />
              <Route exact path="/Classes" element={<Classes/>} />
    
        </Routes>
       
      </BrowserRouter>
    );
  }
}
